import { Injectable } from '@angular/core';
import moment from 'moment';
import { Enums } from '../../../../../../../configs/Enums';

@Injectable()
export class TicketsService {
  hasTickets = (dataTable, appliedTypeGP, appliedSubtypeGPs) => {
    if (!dataTable) {
      return;
    }

    const hasAny = (intervals) => intervals.some((interval) => interval.districts.some((district) => this.filterBy(appliedTypeGP, appliedSubtypeGPs)(district.tickets).length > 0));

    return dataTable.some((data) => {
      return hasAny(data.intervals) || hasAny(data.gp_intervals) || hasAny(data.edo_intervals);
    });
  };

  filterBy = (typeGP, subtypeGPs) => (tickets) => {
    return typeGP
      ? tickets
          .filter((ticket) => ticket.hd_ticket_type.id === typeGP.id)
          .filter((ticket) => {
            if (!subtypeGPs.length) {
              return true;
            }
            return subtypeGPs.findIndex((subtypeGP) => subtypeGP.id === ticket.extra_flags.gp_subtype) !== -1;
          })
      : tickets;
  };

  checkGPInterval(startDate, endDate): boolean {
    const startInterval = moment(startDate).startOf('day').add(1, 'minute').format(Enums.dates.fullFormat);
    const endInterval = moment(endDate).endOf('day').add(-59, 'second').format(Enums.dates.fullFormat);

    return startInterval === startDate && endInterval === endDate;
  }
}
